import { useEffect, useState } from "react";
import { useLang } from "@/i18n/LangContext";

// Office hours in Nicaragua time (America/Managua). null = no fixed hours known.
const HOURS = { sjds: { days: [1, 2, 3, 4, 5], open: 8, close: 17 }, managua: null };
const DAY_EN = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const DAY_ES = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];

const nicaraguaNow = () => {
  const p = Object.fromEntries(new Intl.DateTimeFormat("en-US", { timeZone: "America/Managua", weekday: "short", hour: "numeric", minute: "numeric", hourCycle: "h23" }).formatToParts(new Date()).map((x) => [x.type, x.value]));
  return { day: DAY_EN.indexOf(p.weekday), hour: Number(p.hour) + Number(p.minute) / 60 };
};

const fmt = (h) => `${h > 12 ? h - 12 : h}${h >= 12 ? "pm" : "am"}`;

const nextOpenDay = (h, day, hour) => {
  for (let i = 0; i < 8; i++) {
    const d = (day + i) % 7;
    if (h.days.includes(d) && (i > 0 || hour < h.open)) return { d, today: i === 0, tomorrow: i === 1 };
  }
  return null;
};

export const OfficeHoursBadge = ({ office, className = "" }) => {
  const { tr, lang } = useLang();
  const [now, setNow] = useState(nicaraguaNow);
  useEffect(() => {
    const t = setInterval(() => setNow(nicaraguaNow()), 60000);
    return () => clearInterval(t);
  }, []);
  const h = HOURS[office];
  let open = false;
  let label;
  if (!h) {
    label = tr("By appointment · message to schedule", "Con cita · escríbenos para agendar");
  } else {
    open = h.days.includes(now.day) && now.hour >= h.open && now.hour < h.close;
    if (open) label = tr(`Open now · closes ${fmt(h.close)}`, `Abierto ahora · cierra ${fmt(h.close)}`);
    else {
      const n = nextOpenDay(h, now.day, now.hour);
      const when = n.today ? tr("today", "hoy") : n.tomorrow ? tr("tomorrow", "mañana") : (lang === "es" ? DAY_ES : DAY_EN)[n.d];
      label = tr(`Closed · opens ${when} ${fmt(h.open)}`, `Cerrado · abre ${when} ${fmt(h.open)}`);
    }
  }
  const color = !h ? "border-[#00C9B7]/40 text-[#00C9B7] bg-[#00C9B7]/10" : open ? "border-[#25D366]/50 text-[#25D366] bg-[#25D366]/10" : "border-rose-400/40 text-rose-300 bg-rose-400/10";
  const dot = !h ? "bg-[#00C9B7]" : open ? "bg-[#25D366]" : "bg-rose-400";
  return (
    <span className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-widest ${color} ${className}`} data-testid={`office-hours-badge-${office}`} data-status={!h ? "appointment" : open ? "open" : "closed"}>
      <span className="relative flex w-2 h-2">
        {open && <span className={`absolute inset-0 rounded-full ${dot} animate-ping opacity-75`} />}
        <span className={`relative w-2 h-2 rounded-full ${dot}`} />
      </span>
      {label}
    </span>
  );
};
